import type { LocaleCatalog, MessageSchema } from '../locale';

/**
 * ============================================================================
 * @altkey/i18n - Catálogo Español (es)
 * ============================================================================
 * Implementa íntegramente el `MessageSchema` definido en `../locale.ts`.
 * Cualquier clave faltante o adicional respecto al esquema provoca un error
 * de compilación de TypeScript: esto garantiza que el catálogo español se
 * mantenga sincronizado al 100 % con los otros 4 idiomas soportados.
 * ============================================================================
 */

const messages: MessageSchema = {
  common: {
    appName: 'AltKey',
    ok: 'Aceptar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    loading: 'Cargando…',
    retry: 'Reintentar',
    close: 'Cerrar',
    copy: 'Copiar',
    copied: 'Copiado al portapapeles',
  },
  pairing: {
    title: 'Vincula tus dispositivos',
    scanQrPrompt: 'Escanea el código QR con tu smartphone para vincularlo con este ordenador',
    enterCodeManually: 'O introduce manualmente el código de 6 dígitos',
    waitingForDesktop: 'Esperando la conexión del ordenador…',
    waitingForMobile: 'Esperando la conexión del smartphone…',
    connected: 'Dispositivo conectado',
    disconnected: 'Dispositivo desconectado',
    expired: 'La sesión de vinculación ha caducado. Genera un nuevo código.',
    invalidCode: 'Código no válido. Verifícalo e inténtalo de nuevo.',
    keysExchanged: 'Intercambio de claves de seguridad completado',
    scanDevice: 'Escanear un dispositivo',
    showMyCode: 'Mostrar mi código',
    hostingPrompt: 'Escanea este código con el otro teléfono',
    goBack: 'Torna Indietro',
    disconnectAction: 'Scollega',
    deviceConnected: '🟢 Dispositivo Connesso',
    backToCategories: '← Torna alle Categorie',
  },
  license: {
    proUnlockedPromo:
      'AltKey está en Beta gratuita mundial: todas las funciones Pro están desbloqueadas',
    proUnlockedLicense: 'Funciones Pro desbloqueadas con tu licencia',
    freeTierPrompt: 'Desbloquea las funciones Pro con una licencia AltKey',
    invalidLicense: 'La clave de licencia introducida no es válida',
    enterLicenseKey: 'Introduce tu clave de licencia',
  },
  search: {
    placeholder: 'Busca un símbolo, carácter o palabra clave…',
    noResults: 'No se encontraron resultados',
    resultsCount: '{count} resultados encontrados',
    filterByCategory: 'Filtrar por categoría',
    recentSymbols: 'Símbolos usados recientemente',
  },
  tofuDetector: {
    title: 'Detector de Tofu',
    scanning: 'Buscando caracteres faltantes…',
    issuesFound: 'Se encontraron {count} caracteres no renderizables (tofu)',
    noIssuesFound: 'No se detectaron caracteres faltantes: todo correcto',
    replaceSuggestion: 'Reemplazar con un carácter alternativo compatible',
  },
  macroGenerator: {
    title: 'Generador de Macros',
    recordMacro: 'Grabar nueva macro',
    stopRecording: 'Detener grabación',
    saveMacro: 'Guardar macro',
    macroSaved: 'Macro guardada correctamente',
    deleteMacro: 'Eliminar macro',
  },
  aiCanvasInput: {
    title: 'Entrada de Canvas con IA',
    drawPrompt: 'Dibuja el símbolo que buscas con el dedo o el lápiz óptico',
    recognizing: 'Reconociendo el dibujo…',
    recognitionFailed: 'No se pudo reconocer el símbolo. Intenta dibujarlo de nuevo.',
    insertSymbol: 'Insertar símbolo',
  },
  settings: {
    title: 'Configuración',
    language: 'Idioma',
    theme: 'Tema',
    themeLight: 'Claro',
    themeDark: 'Oscuro',
    themeSystem: 'Seguir sistema',
    startOnBoot: 'Iniciar al encender el ordenador',
    notifications: 'Notificaciones',
    about: 'Acerca de',
    version: 'Versión {version}',
    checkForUpdates: 'Buscar actualizaciones',
    signOut: 'Cerrar sesión',
  },
  home: {
    title: 'Inicio',
    greeting: 'Hola, {name}',
    pairWithDesktop: 'Vincular con el ordenador',
    recentActivity: 'Actividad reciente',
    quickActions: 'Acciones rápidas',
    noRecentActivity: 'No hay actividad reciente que mostrar',
  },
  errors: {
    generic: 'Se produjo un error inesperado. Inténtalo de nuevo.',
    network: 'Error de conexión. Comprueba tu red e inténtalo de nuevo.',
    sessionExpired: 'Tu sesión ha caducado. Vuelve a iniciar sesión.',
    unauthorized: 'No tienes autorización para realizar esta acción.',
    notFound: 'Recurso no encontrado.',
  },
};

const catalog: LocaleCatalog = {
  locale: 'es',
  messages,
};

export default catalog;